import { render, staticRenderFns } from "./UserInvite.vue?vue&type=template&id=57d3aa6a&scoped=true"
import script from "./UserInvite.vue?vue&type=script&lang=js"
export * from "./UserInvite.vue?vue&type=script&lang=js"
import style0 from "./UserInvite.vue?vue&type=style&index=0&id=57d3aa6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d3aa6a",
  null
  
)

export default component.exports